import { useCurrentCreatorbaseUser } from 'Modules/Auth/hooks/useCurrentCreatorbaseUser';
import { useCurrentUserClients } from '@round/creatorbase-helpers';

// The current user's non-agency (creatorbase) clients — this app's own type.
export default function useCurrentUserNonAgencyClients() {
    const { creatorbaseUserId } = useCurrentCreatorbaseUser();
    return useCurrentUserClients(creatorbaseUserId, { isAgency: false });
}
